import { useMemo } from 'react';
import Maybe from 'true-myth/maybe';

import { type CustomAttribute, mapToAttributesWithValue } from '~/shared/data-contract/custom-attribute';

import { useLearningOpportunitiesOptionsQuery } from './use-learning-opportunities-options-query';

export const useLearningOpportunityCustomAttributes = (): readonly CustomAttribute[] => {
    const { data } = useLearningOpportunitiesOptionsQuery();
    const customAttributeOptions = data?.customAttributes;

    return useMemo(
        () => mapToAttributesWithValue(Maybe.of(customAttributeOptions), Maybe.nothing()),
        [customAttributeOptions],
    );
};
